import formBaseMongo from '../../../components/form/form-base-mongo.js'
import {SourcesWasteSourcesOperator, SourcesWasteSourcesGarbage, SourcesWasteSourcesLegalEntity, SourcesWasteSourcesIndividual} from "../../../config/mongo";
import {mongoApi} from "../../../api/api-endpoints";
import {sourcesWasteOffline} from "../../../api/api-offline-endpoints";
import year from "../../../utils/year";

export default {
  mixins: [formBaseMongo],
  data () {
    this.onlyUpdate = false
    return {
      tabView: 'tab1',
      fields: {
        waste_types: [],
        management_type: '',
        municipality_name: '',
        msnIds: []
      }
    }
  },
  computed: {
    wasteTypes () {
      return [
        {id: 1, name: 'Многоквартирный дом'},
        {id: 2, name: 'Индивидиуальный жилой дом'},
        {id: 3, name: 'Офисное/Административное здание'},
        {id: 5, name: 'Иное'}
      ]
    },
    managementTypes () {
      return [
        {id: 1, name: 'Управляющая компания'}
      ]
    }
  },
  methods: {
    onSuccess (response, afterSaveResponse) {
      if (this.fields.id) {
        this.showOnSuccess('Данные обновлены')
      } else {
        this.showOnSuccess('Запись сохранена')
      }
      this.unFreezeFrom()
      this.onSaveForm()
      if (this.onlyUpdate === true) {
        this.onlyUpdate = false
      } else {
        setTimeout(() => {
          this.$router.push(this.getRedirectParams())
        }, 0)
      }
    },
    msnUpdated () {
      if (this.fields.id) {
        this.onlyUpdate = true
        this.sendForm()
      }
    },
    getEditablesEndpointsAndUrl () {
      let postUrl = []
      let tmpEndpoints = []

      postUrl.push(mongoApi.createCollectionItem(SourcesWasteSourcesLegalEntity))
      tmpEndpoints.push(sourcesWasteOffline.garbagesTable(this.$route.name, 'legalEntity'))

      postUrl.push(mongoApi.createCollectionItem(SourcesWasteSourcesIndividual))
      tmpEndpoints.push(sourcesWasteOffline.garbagesTable(this.$route.name, 'individual'))

      // operator
      postUrl.push(mongoApi.createCollectionItem(SourcesWasteSourcesOperator))
      tmpEndpoints.push(sourcesWasteOffline.operatorTable(this.$route.name))

      // add garbages-table
      let years = year.getYears()
      let operations = ['input', 'output', 'detail']
      for (let i = 0; i < years.length; i++) {
        for (let j = 0; j < operations.length; j++) {
          postUrl.push(mongoApi.createCollectionItem(SourcesWasteSourcesGarbage))
          tmpEndpoints.push(sourcesWasteOffline.garbageTable(this.$route.name, years[i], operations[j]))
        }
      }

      return {postUrl: postUrl, tmpEndpoints: tmpEndpoints}
    },
    onLocationChange ($event) {
      let munName = $event.city_with_type || $event.region_with_type || ' - '
      this.$set(this.fields, 'municipality_name', munName)
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
    }

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}
